export default {
  state: {
    munuIndex: '0',
    isCollapse: false,
    munuList: [
      {
        key: '0',
        route: 'total',
        icon: 'el-icon-upload',
        title: '首页'
      },
      {
        key: '1',
        route: 'new',
        icon: 'el-icon-upload',
        title: '校园通上传'
      },
      {
        key: '2',
        route: 'CampusPass',
        icon: 'el-icon-files',
        title: '校园通列表'
      },{
        key: '3',
        route: 'about',
        icon: 'el-icon-chat-dot-square',
        title: '表白墙'
      },{
        key: '4',
        route: 'Tree',
        icon: 'el-icon-s-shop',
        title: '树洞'
      },{
        key: '5',
        route: 'Found',
        icon: 'el-icon-bangzhu',
        title: '失物招领'
      },{
        key: '6',
        route: 'Rotationmap',
        icon: 'el-icon-picture-outline',
        title: '轮播图'
      },{
        key: '7',
        route: 'RotationmapList',
        icon: 'el-icon-s-fold',
        title: '轮播图列表'
      },{
        key: '8',
        route: 'NewMessage',
        icon: 'el-icon-chat-line-square',
        title: '群发消息'
      },
      {
        key: '9',
        route: 'Users',
        icon: 'el-icon-s-custom',
        title: '用户管理'
      }
      ,
      {
        key: '10',
        route: 'Label',
        icon: 'el-icon-chat-line-square',
        title: '标签管理'
      }
    ],
  },
  mutations: {
    setMunuIndex(state, bool) {
      state.munuIndex = bool
    }
  },
  getters: {
    currentMunu(state) {
      return state.munuList[state.munuIndex]
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/nav.js